<template>
  <validation-observer
    v-slot="observer"
    slim
  >
    <form-section
      id="resubmit"
      v-bind="observer"
    >
      <form-row
        label="Your preferred date and time"
        help-text="Please indicate your preferred date and time to submit your quote details.  We will then store these and re-run your quote and endeavour to match you with a panel of providers."
      >
        <v-row>
          <v-col class="col-sm-9 col-12">
            <v-row>
              <v-col class="col-sm-6 col-12">
                <validation-provider
                  v-slot="{ failed }"
                  vid="date"
                  name="Date"
                  rules="listOptionRequired"
                >
                  <v-menu
                    v-model="showResubmitDatepicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs }">
                      <qz-text-field
                        v-model="date"
                        :error-messages="failed ? ['Please select a resubmit date.'] : []"
                        append-icon="mdi-calendar-blank"
                        readonly
                        data-test="resubmit-date"
                        v-bind="attrs"
                        placeholder="Please select a resubmit date"
                        @click:append="showResubmitDatepicker = true;"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      :allowed-dates="isDateAllowed"
                      :min="dateOfInsuranceMin"
                      :max="dateOfInsuranceMax"
                      @input="showResubmitDatepicker = false"
                    />
                  </v-menu>
                </validation-provider>
              </v-col>
              <v-col class="col-sm-6 col-12">
                <validation-provider
                  v-slot="{ failed }"
                  vid="time"
                  name="Time"
                  rules="listOptionRequired"
                >
                  <v-select
                    v-model="time"
                    data-test="time"
                    :items="workingHoursOptions"
                    :error="failed"
                    label="Time"
                    placeholder="Time"
                    hide-details="auto"
                    outlined
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="col-sm-3 col-12">
            <v-btn
              color="success"
              rounded
              x-large
              block
              type="submit"
              data-test="submit_btn"
              @click="resubmit(observer)"
            >
              <span>Submit</span>
              <v-icon
                dark
                right
                size="22"
              >
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  UtcDate,
  ExtDate,
} from '@/helpers/date';

export default {
  name: 'lg-results-resubmit',
  inject: [
    'helpers',
    'constants',
    'productName',
  ],
  props: {
    dateOfInsuranceStart: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showResubmitDatepicker: false,
      date: '',
      time: '',
    };
  },
  computed: {
    workingHoursOptions () {
      return this.helpers.createOptions({ source: this.constants.WORKING_HOURS });
    },
    dateOfInsuranceMin () {
      const today = new ExtDate();
      const todayUtc = new UtcDate();
      let date = today.isAfter(todayUtc) ? today : todayUtc;

      if (this.isEndOfWorkingDay(date)) date = date.addDays(1);

      // We have to set first available working day
      // Only Monday - Friday are allowed
      while (!this.isDateAllowed(date)) {
        date = date.addDays(1);
      }

      return date.format();
    },
    dateOfInsuranceMax () {
      return this.dateOfInsuranceStart;
    },
  },
  created () {
    this.date = this.dateOfInsuranceMin;
  },
  methods: {
    isDateAllowed (val) {
      return [1, 2, 3, 4, 5].includes(new ExtDate(val).getDay());
    },
    isEndOfWorkingDay (date) {
      return date.getHours() >= this.constants.EVENING_TIME;
    },
    async resubmit (observer) {
      try {
        const isValid = await observer.validate();
        if (!isValid) return;

        const date = new ExtDate(this.date);
        const day = date.toLocaleDateString('en-GB', { weekday: 'long' });

        await this.$root.$api.resubmitLgQuote({
          day,
          time: this.time,
          sid: this.$route.params.sid,
          product: this.productName,
        });

        this.$emit('resubmit');
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
